import { getterTypes } from './getter-types';

export default {
  // 获取用户名
  // GET_USERNAME (state) {
  [getterTypes.Getter_User_Name](state) {
    return state.username || window.localStorage.getItem('username');
  },
  // 获取token
  // GET_TOKEN (state) {
  [getterTypes.Getter_Token](state) {
    return state.token ? state.token : window.localStorage.getItem('token');
  },
  // 获取当前语言
  // GET_LANG (state) {
  [getterTypes.Getter_Lang](state) {
    // return state.lang ? state.lang : window.localStorage.getItem('lang');
    let lang = state.lang;
    let langStore = window.localStorage.getItem('lang');
    // langStore = langStore || JSON.stringify({ "id":"4","name":"English","imageUrl":"https://oss-static.umbapp.com/assets/usd.png","code":"en_US","created":"2019-10-22 17:39:56","lastUpdateTime":"2019-10-22 17:39:56","status":1 });
    if (lang && lang.code) {
      return lang;
    } else if (langStore) {
      return JSON.parse(langStore);
    } else {
      return {
        // Hardcoded data for temporary
        id: '4',
        name: 'English',
        imageUrl: 'https://oss-static.umbapp.com/assets/usd.png',
        code: 'en_US',
        created: '2019-10-22 17:39:56',
        lastUpdateTime: '2019-10-22 17:39:56',
        status: 1,
      };
    }
    // return lang;
  },
  // 获取所有语言
  // GET_LANGS (state) {
  [getterTypes.Getter_Langs_List](state) {
    // if (state.langs.length === 0) { // Hardcoded data for temporary. Need to get from API
    //   return [
    //     {
    //       id: '2',
    //       name: '简体中文',
    //       imageUrl: 'https://oss-static.umbapp.com/assets/china.png',
    //       code: 'zh_CN',
    //       created: '2019-10-22 17:38:12',
    //       lastUpdateTime: '2019-10-22 17:38:12',
    //       status: 1,
    //     },
    //     {
    //       id: '4',
    //       name: 'English',
    //       imageUrl: 'https://oss-static.umbapp.com/assets/usd.png',
    //       code: 'en_US',
    //       created: '2019-10-22 17:39:56',
    //       lastUpdateTime: '2019-10-22 17:39:56',
    //       status: 1,
    //     },
    //     {
    //       id: '5',
    //       name: '繁体中文',
    //       imageUrl: 'https://oss-static.umbapp.com/assets/china.png',
    //       code: 'zh_TW',
    //       created: '2019-10-22 17:40:34',
    //       lastUpdateTime: '2019-10-22 17:40:34',
    //       status: 1,
    //     },
    //   ];
    // }
    return state.langs;
  },
  [getterTypes.Getter_Assets_List](state) {
    return state.assetsList;
  },
  // 获取过期时间
  // GET_EXPIRETIME (state) {
  [getterTypes.Getter_ExpireTime](state) {
    return state.expireTime || window.localStorage.getItem('expireTime');
  },
  // 获取最后更新时间
  [getterTypes.Getter_LastUpdateTime](state) {
    return state.lastUpdateTime || window.localStorage.getItem('lastUpdateTime');
  },
  // 获取所有的交易市场
  [getterTypes.Getter_Market_List](state) {
    return state.marketList;
  },
  // 获取当前交易市场
  // GET_CURRENTMARKET (state) {
  [getterTypes.Getter_Current_Market](state) {
    return state.currentMarket;
  },
  // 获取用户详情数据
  // GET_USERINFO (state) {
  [getterTypes.Getter_User_Info](state) {
    if (state.userInfo && state.userInfo.id) {
      state.userInfo.deductionText = state.userInfo.deductionStatus === 1 && 'OEP抵扣享折扣';
      state.userInfo.memberText =
        state.userInfo.memberLevel === 1 ? '普通会员' : state.userInfo.memberLevel === 2 ? '高级会员' : '顶级会员';
    }
    return state.userInfo || {};
  },
  [getterTypes.Getter_User_Vip](state) {
    return state.userVip || {};
  },
  // 获取当前货币类型
  // GET_CURRENCY (state) {
  [getterTypes.Getter_Current_Currency](state) {
    let currency = state.currency;
    if (!currency) {
      currency = window.localStorage.getItem('currency');
      if (currency) {
        currency = JSON.parse(currency);
      } else {
        currency = {};
      }
    }
    return currency;
  },
  // 获取所有货币
  // GET_CURRENCIES (state) {
  [getterTypes.Getter_Currencies_List](state) {
    return state.currencies;
  },
  [getterTypes.Getter_All_Coin](state) {
    return state.allCoin;
  },
  // 获取未读消息数量
  // GET_UNREADMESSAGECOUNT (state) {
  [getterTypes.Getter_Unread_Message_Count](state) {
    return state.unreadMessageCount;
  },
  // 获取资讯研究二级导航
  // GET_INFOMATIONNAV (state) {
  [getterTypes.Getter_Information_Nav](state) {
    return state.infomationNav;
  },
  // 获取socket连接状态
  // GET_SOCKETSTATUS (state) {
  [getterTypes.Getter_Socket_ConnectStatus](state) {
    return state.socketStatus;
  },
  // 获取 移动端侧滑菜单显示与隐藏 状态
  // GET_SLIDERMENUCONTROLS (state) {
  [getterTypes.GET_SLIDERMENU_CONTROLS](state) {
    return state.sliderMenuControls;
  },
  // 获取，所有币种，列表
  [getterTypes.Getter_Coin_List](state) {
    return state.coinList;
  },
  // 获取，所有币币交易对，列表
  [getterTypes.Getter_Trading_Pairs_List](state) {
    return state.tradingPairsList;
  },
  // 获取，收藏的交易对id列表
  [getterTypes.Getter_CollectedMarketSymbols](state) {
    return state.collectedMarketSymbols;
  },
  [getterTypes.Getter_For_Mobile](state) {
    return state.forMobile;
  },
  [getterTypes.Getter_Socket_State](state) {
    return state.socketState;
  },
  [getterTypes.Getter_Burger_Menu_State](state) {
    return state.burgerMenuState;
  },
  [getterTypes.Getter_Wechat_QRCode_State](state) {
    return state.wechatQrCode;
  },
  [getterTypes.GETTER_AFFILIATE_PARTNER_INFO](state) {
    return state.afAndPrInfo;
  },
  [getterTypes.GETTER_PARTNER_INFO](state) {
    return state.partnerInfo;
  },
  [getterTypes.GETTER_PARTNER_TYPE](state){
    return state.partnerType;
  },
  [getterTypes.GETTER_AFFILIATE_TYPE](state){
    return state.affiliateType;
  },

  [getterTypes.GETTER_REWARD_CATEGORIES](state) {
    return state.rewardCategories;
  },
};
